import { cx } from 'classix'

import styles from '../ExpandableContent/ExpandableTextByLink.module.css'

export function SimplePolicies({
	className,
	children,
}: {
	readonly className?: string
	readonly children: React.ReactElement
}) {
	return (
		<div className={cx(styles.expandableContent, className)}>
			<p className={styles.resetContent}>{children}</p>
		</div>
	)
}
